(function(){
    'use strict'

    angular
    .module('app.centrosCostoTercerNivel')
    .controller('CentrosCostoTercerNivel', CentrosCostoTercerNivel);

    CentrosCostoTercerNivel.$inject = ['$animationsSrv', 'CentrosCostoTercerNivelService', 'logger', '$location', 'UserInfoService'];

    function CentrosCostoTercerNivel($animationsSrv, CentrosCostoTercerNivelService, logger, $location, UserInfoService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;

        vm.centrosCostoTercerNivel = [];
        vm.title = 'Centros Costo';

        vm.goToEdit = function(centroCosto){
            
            var path = '/editar-centro-costo-tercer-nivel/';

            if(centroCosto){
                $location.path(path + centroCosto.id);
            }
            else{
                $location.path(path);
            }
            
        };

        vm.openModal = function(modalName){
            $(modalName).modal('toggle');    
        };

        getAll();

        function getAll(){

            var promise = CentrosCostoTercerNivelService.getAll(UserInfoService.getCompaniaId());

            promise
            .then(function(centrosCostoTercerNivel){
                vm.centrosCostoTercerNivel = centrosCostoTercerNivel;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener los centros de Costo Tercer Nivel.');
                        break;
                }
            });
        };

        vm.delete = function(centroCosto){
            var promise = CentrosCostoTercerNivelService.remove(centroCosto);
            
            promise
            .then(function(response){
                vm.centrosCostoTercerNivel = vm.centrosCostoTercerNivel.filter(function(g) {
                    return g.id !== centroCosto.id;
                });
                logger.success('Centro de Costo Tercer Nivel eliminado con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(error.data.Message);
                        break;
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                    default:
                        logger.error('Hubo un erro al eliminar el Centro de Costo Tercer Nivel');
                        break;
                }
                
            });   
        };

    }
})();